Drupal.behaviors.utilities = {
  attach(context) {
    const pageTitle = context.querySelector('#block-bnm2024-page-title h1');
    
    if (pageTitle.innerText === "Create Send Files") {
      pageTitle.textContent = "Send Files";
    }

    if (window.location.pathname === '/node/add/article') {

      const submitButton = context.querySelector('#edit-submit');
      const singleFileField = context.querySelector('#edit-field-single-file-0-target-id');
      
      function disableSubmitButton() {
        submitButton.style.cursor = 'not-allowed';
        submitButton.setAttribute('disabled', '');
      }
      
      function enableSubmitButton() {
        submitButton.style.cursor = 'auto';
        submitButton.removeAttribute('disabled');
      }

      function checkRequiredFields() {
        const multipleFiles = context.querySelector('#edit-field-files-wrapper details .entities-list');

        if (singleFileField.value || multipleFiles.childElementCount > 0) {
          enableSubmitButton();
        } else {
          disableSubmitButton();
        }
      }

      disableSubmitButton();

      submitButton.addEventListener('mouseover', checkRequiredFields);
    }
  }
}